import { Route } from "vue-router";
import store from "@service/store";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { substituteEventId } from "@service/router/helpers/substituteEventId";
import { noEventId } from "@service/router/getters";

export const handleFalsyEventIdParam = async (to: Route, selectedEventId: string | null | undefined, isEventFromRouteAvailable: boolean) => {
    const isSelectedIdSetFromRoute = await store.dispatch('events/setSelectedIfExist', to.params.eventId);
    //неправильное значение selectedEventId может быть когда переход идет с помощью AfterLoginPath
    //неправильное значение to.params.eventId может быть при переходе по ссылке мероприятия которое не доступно
    if (isSelectedIdSetFromRoute) {
        return substituteEventId(to, to.params.eventId);
    }

    if (!isEventFromRouteAvailable) {
        const registerResult = await store.dispatch('events/registerToOpenEvent', to.params.eventId);

        if (registerResult) {
            return substituteEventId(to, to.params.eventId);
        }
    }

    if (isEventFromRouteAvailable && selectedEventId) {
        return substituteEventId(to, selectedEventId);
    }

    if (to.params.eventId == noEventId) { return null; }

    //preventing opening not available event
    if (store.getters["events/eventAvailable"](selectedEventId)) {
        return { name: RouteNamesEnum.home, params: { backend: to.params.backend, eventId: selectedEventId || noEventId }, hash: to.hash };
    }

    //setSelected вызывается т.к. при setInitSelected значение берется из LS
    await store.dispatch("events/setSelected", null);
    await store.dispatch("events/setInitSelected", null);
    to.params.eventId = '';

    return { name: RouteNamesEnum.home, params: to.params };
}
